import { render, staticRenderFns } from "./RefundBookingDialog.vue?vue&type=template&id=06c4258e"
import script from "./RefundBookingDialog.vue?vue&type=script&lang=ts"
export * from "./RefundBookingDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports